import { isFeatureEnabled } from 'owa-feature-flags';
import {
    GdprAdsPrefsOptions,
    GdprAdsV2Options,
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export default function saveConsentString(consentString: string) {
    let currentOptions;
    if (isFeatureEnabled('fwk-gdprAdsV2')) {
        currentOptions = getOptionsForFeature<GdprAdsV2Options>(OwsOptionsFeatureType.GdprAdsV2);
    } else {
        currentOptions = getOptionsForFeature<GdprAdsPrefsOptions>(
            OwsOptionsFeatureType.GdprAdsPrefs
        );
    }

    const newOptions = {
        ...currentOptions,
        consentString,
    };

    if (isFeatureEnabled('fwk-gdprAdsV2')) {
        return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
            OwsOptionsFeatureType.GdprAdsV2,
            newOptions
        );
    } else {
        return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
            OwsOptionsFeatureType.GdprAdsPrefs,
            newOptions
        );
    }
}
